/*
 * @Autor: 李丁
 * @Date: 2023-05-31
 */
import axios from 'axios'
import { message } from '@/utils/message'
import store from '@/store'
import { getToken } from '@/utils/auth'
import route from "../router";
import router from "../router";
import define from '@/utils/define'
const { APIURl } = require('./apiUrl')
// create an axios instance
const service = axios.create({
  baseURL: APIURl, // url = base url + request url
  withCredentials: false, // send cookies when cross-domain requests
  timeout: define.timeout, // request timeout
})

// request interceptor
service.interceptors.request.use(
  config => {
    config.headers['Content-Type'] = 'application/json;charset=UTF-8'
    // do something before request is sent
    if (store.getters.token) {
      config.headers['Authorization'] = getToken()
    }
    if (config.method === 'get' && config.params) {
      let url = config.url + '?';
      for (const propName of Object.keys(config.params)) {
        const value = config.params[propName];
        var part = encodeURIComponent(propName) + "=";
        if (value !== null && typeof (value) !== "undefined") {
          if (typeof value === 'object') {
            for (const key of Object.keys(value)) {
              let params = propName + '[' + key + ']';
              var subPart = encodeURIComponent(params) + "=";
              url += subPart + encodeURIComponent(value[key]) + "&";
            }
          } else {
            url += part + encodeURIComponent(value) + "&";
          }
        }
      }
      url = url.slice(0, -1);
      config.params = {};
      config.url = url;
    }
    return config
  },
  error => {
    // do something with request error
    if (process.env.NODE_ENV === 'development') {
      console.log(error) // for debug
    }
    return Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  response => {
    const res = response.data
    // 特殊接口处理
    if (response.config.responseType === 'blob') {
      return res
    }
    if (res.code !== 200) {
      if (response.config.url.indexOf('/login') < 0) {
        if (res.code === 600 || res.code === 601 || res.code === 602 || res.code === 401) {
          //登录过期处理
          message({
            message: '登录过期，请重新登录',
            type: 'error',
          })
          store.dispatch('user/resetToken')
          route.name == 'home' || route.name == 'eqment' ? '' : router.replace({ path: '/' })
          setTimeout(() => {
            location.reload();
          }, 1000)
        }
        else {
          message({
            message: res.msg,
            type: 'error',
          })
        }
      }
      else {
        message({
          message: res.msg,
          type: 'error',
          duration: 1500
        })
      }
      return Promise.reject(res)
    }
    else {
      return res
    }
  },
  error => {
    if (process.env.NODE_ENV === 'development') {
      console.log(error, 'debug') // for debug
    }
    let status = error.response.data.code
    if (status === 600 || status === 601 || status === 602 || status === 401) {
      //登录过期处理
      message({
        message: '登录过期，请重新登录',
        type: 'error',
      })
      store.dispatch('user/resetToken')
      route.name == 'home' || route.name == 'eqment' ? '' : router.replace({ path: '/' })
      setTimeout(() => {
        location.reload();
      }, 1000)
    } else {
      message({
        message: error,
        type: 'error',
        duration: 1500
      })
    }
    return Promise.reject(error)
  }
)

export default service